import { assert, Test } from "oc-e2e-testrunner";
import { resetArrangement } from "./utils";
import { v2 } from "oc-threejs/short3";
import { setEmptyAsMauer } from "../components/zauneditor/ZaunCircleMenuItemEmptyAsMauer";

export default {
  name: "TestLichteWeite",
};

const isVoreinstellungMitEAntrieb =
  APP.richMetadata.findAuswahlwert("E_Antrieb_mit")?.Voreinstellung;

export const testLichteWeiteZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[2];
  assert.equals(1.78, element.breite);
  assert.equals(1.74, element.lichteWeite);
};

export const testLichteWeiteTor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[2];
  assert.equals(1.74, element.lichteWeite);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
    size: v2(0.98, 1.8),
  });
  agt.update3d();
  assert.equals(0.98, element.breite);
  assert.equals(1.005, element.lichteWeite);

  // montageplate 100,5 cm an Montageplatten
  // anschlagprofil 102 cm
};

export const testLichteWeiteDoppeltor: Test = async () => {
  assert.isTrue(isVoreinstellungMitEAntrieb);
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [7]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[2];
  assert.equals(1.74, element.lichteWeite);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  element.change({
    massAuswahlwert,
    size: v2(2.78, 1.8),
  });
  agt.update3d();
  assert.equals(2.78, element.breite);
  assert.equals(2.83, element.lichteWeite);
  element.behalteLichteweite(
    () => (element.eAntriebAuswahlwert = APP.richMetadata.findAuswahlwert("E_Antrieb_ohne"))
  );
  agt.update3d();
  assert.equals(2.8, element.breite);
  assert.equals(2.83, element.lichteWeite);
};

export const testLichteWeiteZaunfeldAnMauerMitUMProfil: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  setEmptyAsMauer(s.empties[0]);
  agt.update3d();
  const element = s.getElemente()[0];
  assert.equals(1.78, element.breite);
  assert.equals(1.74, element.lichteWeite);
};

export const testLichteWeiteTorDrückerAnMauer: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  setEmptyAsMauer(s.empties[0]);
  agt.update3d();
  const element = s.getElemente()[0];
  assert.equals(1.74, element.lichteWeite);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
    size: v2(0.98, 1.8),
  });
  agt.update3d();
  assert.equals(0.98, element.breite);
  assert.equals(1.02, element.lichteWeite);
};

export const testLichteWeiteTorKlobenAnMauer: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  setEmptyAsMauer(s.empties[0]);
  agt.update3d();
  const element = s.getElemente()[0];
  assert.equals(1.74, element.lichteWeite);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
    size: v2(0.98, 1.8),
  });
  element.anschlagAuswahlwert = APP.richMetadata.findAuswahlwert("Anschlag_rechts");
  agt.update3d();
  assert.equals(0.98, element.breite);
  assert.equals(1.005, element.lichteWeite);
};
